import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FullscreenMessageComponent } from '@examdojo/core/fullscreen-message';
import { provideFaIcons } from '@examdojo/icons';
import { faMessageExclamation } from '@fortawesome/pro-light-svg-icons';

@Component({
  selector: 'y42-not-found',
  templateUrl: './not-found.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'flex flex-col h-full justify-center' },
  imports: [FullscreenMessageComponent],
})
export class NotFoundComponent {
  constructor() {
    provideFaIcons([faMessageExclamation]);
  }
}
